const ID_OPERATORS = ["eq", "!eq", "in", "!in"];

const psaIntegrationSchema = {
  $id: "/psaintegration",
  title: "PSAIntegration",
  type: "object",
  properties: {
    companyId: { type: "string" },
    manageUrl: { type: "string" },
    name: { type: "string" },
    privateKey: { type: "string" },
    publicKey: { type: "string" },
    orgId: {
      type: "string",
      format: "uuid",
      validOperators: ID_OPERATORS,
    },
    catchall: { type: "string" },
    psaType: { type: "string", enum: ["Connectwise", "Halo", "Autotask"] },
    enabled: { type: "boolean" },
    connectionStatus: { type: "string" },
    lastConnection: { type: "string", format: "date-time" },
    created: { type: "string", format: "date-time", readOnly: true },
  },
  required: [],
  additionalProperties: true,
};

export default psaIntegrationSchema;
